import './filter.css';
import _ from 'lodash';
import { useState, useEffect, useRef, useContext } from 'react';
import postal from 'postal';

import styled from 'styled-components';
import Float from '../Float';
import TextBox from '../TextBox';
import LabeledCheckBox from '../LabeledCheckBox';
import IfmsDate from '../Date';
import InputControlRow from '../layout/InputControlRow';
import PrimaryButton from '../PrimaryButton';
import IfmsModal from '../IfmsModal';

import CheckBox from '../CheckBox';
import CheckBoxIcon from '../CheckBoxIcon';
import { dateTextToIso, formatDate } from '../../dateUtils';
import Select from '../Select';
import SecondaryButton from '../SecondaryButton';
import { Search, resetSearchKeepPaging } from '../../filtering';
import IconButton from '../IconButton';
import SearchIcon2 from '../../img/Search2.svg';
import SearchIcon2_D from '../../img/Search_Dark2.svg';
import SearchIcon3 from '../../img/toolbar-multisearch-light.svg';
import SearchIcon3_D from '../../img/toolbar-multisearch-dark.svg';
import SearchIcon4 from '../../img/multisearch_light.svg';
import SearchIcon4_D from '../../img/multisearch_dark.svg';
import periodCloseIcon from '../../img/PeriodClose.svg';
import periodCloseIcon2 from '../../img/periodclose-12.svg';
import opCloseIcon from '../../img/OPClose.svg';
import opCloseIcon2 from '../../img/opclose-12.svg';
import accountCloseIcon from '../../img/AccountClose.svg';
import accountCloseIcon2 from '../../img/accountingclose-12.svg';
import ApplicationContext from '../../ApplicationContext';
import useSuntekSettings from '../../hooks/useSuntekSettings';
import { ListCustomFilterRenderer } from '../../components/common/AbstractListView';
import { changeRQEvent } from '../../components/common/commonListRenderers';
import RadioButton from '../RadioButton';
import useGlobalOkDialog from '../../hooks/useGlobalOkDialog';

const nullSearchEnableColumns = ['status', 'recognized', 'moveType', 'void', 'draft', 'isVoid', 'jobType', 'trStatus', 'trStatus2', 'taskStatus'];

const dateNotNullEnableColumns = ['confirmDate'];
const dateNotNullLabel = 'Recog';

const FilterContent = styled.div`
  margin: 10px;
  margin-top: 0px;
  font-family: Arial;

    .header-strong {
      margin-top: 5px;
      font-style: normal;
      font-weight: bold;
      font-size: 16px;
      color: #252A37;
      line-height: 28px;
    }

    .header {
      margin-top: 3px;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      color: #252A37;
      line-height: 28px;
    }
`;

/*
const Pager = styled.div`
  margin-left: 5px;
  width: 135px;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;

  div {
    margin-left: 2px;
    margin-right: 2px;
  }
`;
*/

const IncludeSearchProperties = [
  'general1',
  'general2',
  'general3',
  'date',
  'date1',
  'date2',
  'number',
  'number1',
  'number2',
  'generalText1',
  'generalText2',
  'generalText3',
  'generalNullOrEmpty',
  'dateFrom',
  'dateTo',
  'dateFrom1',
  'dateTo1',
  'dateFrom2',
  'dateTo2',
  'dateNullOrEmpty',
  'dateNotNullFields',
  'numberFrom',
  'numberTo',
  'numberFrom1',
  'numberTo1',
  'numberFrom2',
  'numberTo2',
  'numberNullOrEmpty',
  'extras',
];

function searchInFilterOrderComparer(l:any, r:any) {
  if (!l || !r) {
    return false;
  }

  const result = _.isEqual(_.pick(l, IncludeSearchProperties), _.pick(r, IncludeSearchProperties));
  return result;
}

// Tries to get the data from DOM in order to have to change dependencies on all screens to add additional title param
function extractScreenTitleBar() {
  const titleNodes = document.querySelectorAll('.ifms-screen-title-bar > h2');
  if (titleNodes && titleNodes.length) {
    const n = titleNodes[0] as HTMLElement;
    return n.innerText;
  }
  return '';

}

function StatusFilter({
  value,
  onChange,
  onEnter
}: {
  value: string,
  onChange: (x:string) => void,
  customRenderers : any,
  accessor : any,
  onEnter : any
}) {
  const items = [
    { label: '', value: '' },
    { label: 'OP Close', value: 'OC', icon: opCloseIcon2, iconHeight: '12px', iconMargin: '0 0 0 4px' },
    { label: 'Accounting Close', value: 'AC', icon: accountCloseIcon2, iconHeight: '12px' },
    { label: 'Period Close', value: 'PC', icon: periodCloseIcon2, iconHeight: '12px' },
  ]

  return (
    <Select
      name='ifms-filter-status-select'
      selectId='ifms-filter-status'
      value={value}
      items={items}
      onChange={e => onChange(e.target.value)}   
      applySearchWithEnter={onEnter}
    />
  );
}

function StatusFilterNotUseFileLocked({
  value,
  onChange,
  onEnter
}: {
  value: string,
  onChange: (x:string) => void,
  customRenderers : any,
  accessor : any,
  onEnter : any
}) {
  const url = `${window.location.pathname}${window.location.search}`;
  const isInvoList = url.includes('/common/joblistview/invoice/accounting?parentOp=billings');
  const isBillList = url.includes('/common/joblistview/bill/accounting?parentOp=billings');
  const isCrDbList = url.includes('/common/joblistview/crdb/accounting?parentOp=billings');

  const items = (isInvoList || isBillList || isCrDbList)
  ? [
      { label: '', value: '' },
      { label: 'Accounting Close', value: 'AC', icon: accountCloseIcon2, iconHeight: '12px' },
      { label: 'Period Close', value: 'PC', icon: periodCloseIcon2, iconHeight: '12px' },
    ]
  : [
      { label: '', value: '' },
      { label: 'Period Close', value: 'PC', icon: periodCloseIcon2, iconHeight: '12px' },
    ]

  return (
    <Select
      name='ifms-filter-status-select'
      selectId='ifms-filter-status'
      value={value}
      items={items}
      onChange={e => onChange(e.target.value)}
      applySearchWithEnter={onEnter}
    />
  );
}

function GeneralFilter({disabled, value, onChange, accessor, customRenderers, onEnter}:any) {

  if (accessor && customRenderers) {
    const customRenderer = customRenderers.find((x:any) => x.accessor === accessor);
    if (customRenderer) {
      return customRenderer.renderer({disabled, value, onChange, onEnter});
    }
  }

  return (
    <TextBox
      name='ifms-filter-general-searchTextBox'
      textId="ifms-filter-general"
      disabled={disabled}
      value={value}
      onChange={e => onChange(e.target.value)}
      onEnter={onEnter}
    />
  );
}

function TaskStatusFilter({value,onChange, onEnter}: {
  value: string,
  onChange: (x:string) => void,
  accessor : any,
  customRenderers : any,
  onEnter : any
}) {
  const items = [
    { label: '', value: '' },
    { label: 'Pending', value: 'Pending' },
    { label: 'Done', value: 'Done' },
    { label: 'GPS', value: 'GPS'},
  ]

  return (
    <Select
      name='ifms-filter-taskStatus-select'
      selectId='ifms-filter-taskStatus'
      value={value}
      items={items}
      onChange={e => {onChange(e.target.value)}}   
      applySearchWithEnter={onEnter}
    />
  );
}

function TaskStatusPendingFilter({value,onChange, onEnter}: {
  value: string,
  onChange: (x:string) => void,
  customRenderers : any,
  accessor : any,
  onEnter : any
}) {
  const items = [
    { label: '', value: '' },
    { label: 'Pending', value: 'Pending' },]

  return (
    <Select
      name='ifms-filter-taskStatus-select'
      selectId='ifms-filter-taskStatus'
      value={value}
      items={items}
      onChange={e => onChange(e.target.value)}   
      applySearchWithEnter={onEnter}
    />
  );
}

function SchStatusFilter({value,onChange, onEnter}: {
  value: string,
  onChange: (x:string) => void,
  accessor : any,
  customRenderers : any,
  onEnter : any
}) {
  const items = [
    { label: 'Active', value: 'Active' },
    { label: 'Paused', value: 'Paused' },
    { label: 'Completed', value: 'Completed' },]

  return (
    <Select
      name='ifms-filter-schStatus-select'
      selectId='ifms-filter-schStatus'
      value={value}
      items={items}
      onChange={e => {onChange(e.target.value)}}   
      applySearchWithEnter={onEnter}
    />
  );
}

function FilterSummary({ filterOrder, search, filterId, deleteFilterFieldNames, setDeleteFilterFieldNames, isMultipleSearchChecked }: any) {
  if (!filterOrder || filterOrder.length <= 0) {
    return <div>&nbsp;</div>;
  }

  function renderDateRangeValue(x: any) {
    if (x.value === dateNotNullLabel) {
      return <span>{x.value}</span>;
    }

    const parts = x.value ? x.value.split('~') : [];
    const from = parts.length > 0 ? formatDate(parts[0].trim()) : '';
    const to = parts.length > 1 ? formatDate(parts[1].trim()) : '';

    return <span>{formatDate(from)} ~ {formatDate(to)}</span>;
  }

  function renderValue(x: any) {
    if (x.type === 'bool') {
      return <CheckBoxIcon value={x.value} />;
    }
    if (x.type === 'date') {
      return renderDateRangeValue(x);
    }

    //Container Tracking Column 검색 시 Tracking Event로만 검색되도록 수정하여
    // 값이 나올때도 Track Event만 표시되도록 조건 추가
    if(x.columnId === "trStatus" && x.label === "Container Tracking"){
      return <>
        {changeRQEvent(x.value, true)}
      </>
    }

    return (
      <>
        {x.value}
      </>
    );
  }

  function getSearchHistoryValue(recordCount: number) {
    let result = '';
    if (recordCount !== undefined && recordCount !== null) {
      const formattedCount = recordCount.toLocaleString();
      result = `${formattedCount} Items found`;
    }
    return result;
  }

  return (
    <div style={{ height: '100%', overflowY: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none' }} className="filter-summary-scroll" >
      {filterOrder.map((x: any, i: number) => (
        <div key={i} style={{ marginLeft: '10px', display: 'flex', alignItems: 'flex-start' }} >
          <div style={{ marginRight: '7px', marginTop: '-1px', flexShrink: 0 }}>
            <CheckBox
              value={isMultipleSearchChecked && deleteFilterFieldNames.every((id: string) => id !== x.columnId) && (i !== 0 || filterOrder[0].columnId !== filterId)}
              disabled={(i !== 0 || filterId === x.columnId) || (i === 0 && filterId === x.columnId) || filterOrder.some((x: any) => x.columnId === filterId)}
              onChange={(checked: boolean) => {
                setDeleteFilterFieldNames((prev: Array<string>) =>
                  checked
                    ? prev.filter(id => id !== x.columnId)
                    : [...prev, x.columnId]
                );
              }}
            />
          </div>
          <div id={`search-history-line-${i}`} style={{ flex: 1, minWidth: 0, display: 'flex' }} >
            <div style={{ paddingRight: '25px', whiteSpace: 'nowrap' }}>
              Search {filterOrder.length - i}
            </div>

            <div style={{ paddingRight: '6px', whiteSpace: 'nowrap' }}>
              {x.label}:
            </div>

            <div style={{ flex: 1, display: 'block', wordBreak: 'break-all' }}>
              {renderValue(x)}
            </div>
          </div>
          <div id={`search-history-Record-${i}`} style={{ width: '185px', paddingLeft: '30px', display: 'flex', alignItems: 'flex-start', flexShrink: 0 }} >
            <div style={{ flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} >
              {getSearchHistoryValue(x.count)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}

function FilterEntry({
  filterId,
  filterLabel,
  entryType,
  value,
  onChange,
  nullOrEmpty,
  setNullOrEmpty,
  dateNotNull,
  setDateNotNull,
  customRenderers,
  applySearch,
  floatOverride,
  decimals,
  noNullOrEmptySearches,
  useCustomRenderes,
}: any) {

  // Status column has special rendering and to avoid duplication it is handled here. If no customRenderers are available,
  // render this as a default
  if (filterId === 'status' && !customRenderers.some((x: any) => x.accessor === filterId)) {
    return (

      <div style={{ width: '350px', height: '55px' }}>
        <InputControlRow label="Status" bold>
          {customRenderers.some((x: any) => x.accessor === 'statusNotUseFileLocked') ?
            <StatusFilterNotUseFileLocked
              value={value}
              onChange={value => {
                onChange(value);
                setNullOrEmpty(value);
              }}
              customRenderers={customRenderers}
              accessor={filterId}
              onEnter={applySearch}
            />
            :
            <StatusFilter
              value={value}
              onChange={value => {
                onChange(value);
                setNullOrEmpty(value);
              }}
              customRenderers={customRenderers}
              accessor={filterId}
              onEnter={applySearch}
            />
          }
        </InputControlRow>

      </div>
    );
  }

  if (filterId === 'taskStatus' && !customRenderers.some((x: any) => x.accessor === filterId)) {
    return (

      <div style={{ width: '350px', height: '55px' }}>
        <InputControlRow label="Status" bold>
          <TaskStatusFilter
            value={value}
            onChange={value => {
              onChange(value);
              setNullOrEmpty(value);
            }}
            customRenderers={customRenderers}
            accessor={filterId}
            onEnter={applySearch}
          />
        </InputControlRow>

      </div>
    );
  }

  if(filterId === 'schStatus' && !customRenderers.some((x: any) => x.accessor === filterId)){
        return (

      <div style={{ width: '350px', height: '55px' }}>
        <InputControlRow label="Status" bold>
          <SchStatusFilter
            value={value}
            onChange={value => {
              onChange(value);
              setNullOrEmpty(value);
            }}
            customRenderers={customRenderers}
            accessor={filterId}
            onEnter={applySearch}
          />
        </InputControlRow>

      </div>
    );
  }


  if (!entryType) {
    return (
      <div>&nbsp;</div>
    );
  }

  const checkbox = noNullOrEmptySearches.some((x: any) => x.accessor === filterId) ? null : 
    <div style={{ width:'230px', marginTop: '10px' }}>
    <LabeledCheckBox
      reverse
      labelSize="215px"
      label="Search by Null or Empty"
      name='search-search-by-null-or-empty'
      value={nullOrEmpty}
      disabled={dateNotNull}
      onChange={nullOrEmpty => {
        if (nullOrEmpty) {
          if (entryType === 'date' || entryType === 'number') {
            value.to = null;
            value.from = null;
            onChange(value);
          }
          else
            onChange(null);
        }
        setNullOrEmpty(nullOrEmpty);
      }
      }
    />
      {/* <LeftRightSplit
        leftSize="100px"
        rightSize="calc(100% - 100px)"
        left={
          <div style={{ marginLeft: '15px', position: 'relative', top: '-2px' }}>
            <CheckBox value={nullOrEmpty} onChange={nullOrEmpty => {
              if (nullOrEmpty) {
                if (entryType === 'date' || entryType === 'number') {
                  value.to = null;
                  value.from = null;
                  onChange(value);
                }
                else
                  onChange(null);
              }
              setNullOrEmpty(nullOrEmpty);
            }
            } />
          </div>
        }
        right={
          <>Search by Null or Empty</>
        }
      /> */}
    </div>;

  if (entryType === 'general') {
    return (
      <div style={{ width: '350px' }}>
        {/* <InputControlRow label={filterLabel} bold> */}
          <GeneralFilter
            disabled={nullOrEmpty}
            value={value}
            onChange={onChange}
            customRenderers={customRenderers}
            accessor={filterId}
            onEnter={applySearch}
          />
        {/* </InputControlRow> */}
        {/* {entryType === 'general' && !useCustomRenderes && filterId !== 'status' ?
          <span style={{ fontSize: '10px' }}>
            Enter a keyword to search for texts starting with it.<br />
            Add “%” before the keyword to search for texts containing it.
          </span>
          :
          <></>
        } */}
        <div style={{ paddingTop: '5px' }}>
          {checkbox}
        </div>
      </div>
    );
  }
  if (entryType === 'date') {
    const showDateNotNull = dateNotNullEnableColumns.some(x => x === filterId);
    return (
      <div style={{ width: showDateNotNull ? '520px' : '350px' }}>
        {/* <InputControlRow label={filterLabel} bold> */}
        <div style={{ display: 'flex' }}>
          <div style={{ float: 'left', width: '90px' }}>
            <IfmsDate
            name='ifms-filter-search-datefrom'
              dateId="ifms-filter-datefrom"
              value={value?.from}
              disabled={nullOrEmpty || dateNotNull}
              onChange={from => { 
                const prevFrom = value?.from ?? '';
                const isDelete = (from??'').length < prevFrom.length;
                const isEqual = value.from === value.to;

                if (isDelete) {
                  if (isEqual) {
                    onChange({ from, to: from });
                  } else {
                    onChange({ from, to: value.to });
                  }
                } else {
                  onChange({from, to: from});
                }
                }
              
              }
              onEnter={applySearch}
              // onTabNext={() => {
              //   const focusElement = document.getElementById('ifms-filter-dateto') as HTMLInputElement;
              //   if (focusElement) {
              //     focusElement.focus();
              //     focusElement.select();
              //     return true;
              //   }
              //   return false;
              // }}
              noRangeCheck
              useFollowDate
            />
          </div>
          <div style={{ float: 'left', marginLeft: '20px' }}>
            <label style={{ fontSize: '10px', paddingTop: '8px' }}>~</label>
          </div>
          <div style={{ float: 'left', width: '90px', marginLeft: '20px' }}>
            <IfmsDate
             name='ifms-filter-search-dateto'
              dateId="ifms-filter-dateto"
              disabled={nullOrEmpty || dateNotNull}
              value={value?.to}
              onChange={to => onChange({ from: value?.from, to })}
              onEnter={applySearch}
              noRangeCheck
              useFollowDate
            />
          </div>
          {showDateNotNull &&
            <div style={{ float: 'left', width: '160px', marginLeft: '40px', marginTop: '6px' }}>
              <LabeledCheckBox
                reverse
                labelSize="145px"
                label="Recog"
                name='search-search-by-not-null'
                value={dateNotNull}
                disabled={nullOrEmpty}
                onChange={dateNotNull => {
                  if (dateNotNull) {
                    onChange({ from: null, to: null });
                  }
                  setDateNotNull(dateNotNull);
                }}
              />
            </div>
          }
        </div>
        {/* </InputControlRow> */}
        <div style={{ paddingTop: '5px' }}>
          {checkbox}
        </div>
      </div>
    );
  }
  if (entryType === 'number') {
    const customRenderer = customRenderers.find((x:any) => x.accessor === filterId);
    if (filterId && customRenderer) {
      return customRenderer.renderer({nullOrEmpty, value, onChange});
    }

    return (
      <div style={{ width: '350px' }}>
        <div style={{ display: 'flex' }}>
          <div style={{ float: 'left', width: '90px' }}>
            <Float
              floatId="ifms-filter-number1"
              disabled={nullOrEmpty}
              value={value?.from}
              onChange={from => onChange({ from, to: from })}
              onEnter={applySearch}
              decimals={floatOverride ? 0 : decimals}
              // onTabNext={() => {
              //   const focusElement = document.getElementById('ifms-filter-number2') as HTMLInputElement;
              //   if (focusElement) {
              //     focusElement.focus();
              //     focusElement.select();
              //     return true;
              //   }
              //   return false;
              // }}
            />
          </div>
          <div style={{ float: 'left', marginLeft: '5px' }}>
            <label style={{ fontSize: '10px', paddingTop: '8px' }}>~</label>
          </div>
          <div style={{ float: 'left', width: '90px', marginLeft: '5px' }}>
            <Float
              floatId="ifms-filter-number2"
              disabled={nullOrEmpty}
              value={value?.to}
              onChange={to => onChange({ from: value?.from, to })}
              onEnter={applySearch}
              decimals={floatOverride ? 0 : decimals}
            />
          </div>
        </div>
        {/* </InputControlRow> */}
        <div style={{ paddingTop: '5px' }}>
          {checkbox}
        </div>
      </div>
    );
  }
  if (entryType === 'bool') {
    if (filterId && customRenderers) {
      const customRenderer = customRenderers.find((x:any) => x.accessor === filterId);
      if (customRenderer?.renderer) {
        return (
          // <InputControlRow label={filterLabel} bold>
          <div>
            {customRenderer.renderer({ nullOrEmpty, value, onChange })}
          </div>
          // </InputControlRow>
        );
      }
    }
    
    return (
      <div style={{ height: '20px' }}>
        <CheckBox name='ifms-filter-bool-search-check' focusId="ifms-filter-bool" label='Search for Checked Box' value={value} onChange={onChange} />
      </div>
    );
  }

  return (
    <div>&nbsp;</div>
  );
}

function getFilterLabel(columnAccessor:any, entryType:any, other:any) {
  const generalFilters = other.generalFilters;
  const dateFilters = other.dateFilters;
  const numberFilters = other.numberFilters;
  const boolFilters = other.boolFilters;

  if (entryType === 'general') {
    return generalFilters.find((x:any) => x.accessor === columnAccessor)?.Header || '';
  } else if (entryType === 'date') {
    return dateFilters.find((x:any) => x.accessor === columnAccessor)?.Header || '';
  } else if (entryType === 'number') {
    return numberFilters.find((x:any) => x.accessor === columnAccessor)?.Header || '';
  } else if (entryType === 'bool') {
    return boolFilters.find((x:any) => x.accessor === columnAccessor)?.Header || '';
  }  

  return '';
}

function getPresetType(filterColumnPreset:any, other:any) {
  const generalFilters = other.generalFilters;
  const dateFilters = other.dateFilters;
  const numberFilters = other.numberFilters;
  const boolFilters = other.boolFilters;

  if (filterColumnPreset) {
    if (dateFilters.findIndex((x:any) => x.accessor === filterColumnPreset) >= 0) {
      return 'date';
    } else if (numberFilters.findIndex((x:any) => x.accessor === filterColumnPreset) >= 0) {
      return 'number';
    } else if (generalFilters.findIndex((x:any) => x.accessor === filterColumnPreset) >= 0) {
      return 'general';
    } else if (boolFilters.findIndex((x:any) => x.accessor === filterColumnPreset) >= 0) {
      return 'bool';
    }
  }
  return null;
}

function getPresetEmptySlot(search: any, entryType: any, multipleSearch: boolean) {
  const extraCount = search && search.extras ? search.extras.length : 0;
  if (!multipleSearch) {
    if (entryType === 'general' || entryType === 'bool')
      return 'general1';
    else if (entryType === 'date')
      return 'date';
    else if (entryType === 'number')
      return 'number';
  }
  if (entryType === 'general' || entryType === 'bool') {
    if (!search.general1) {
      return 'general1';
    }
    if (!search.general2) {
      return 'general2';
    }
    if (!search.general3) {
      return 'general3';
    }
    return `extra-${extraCount}-general`;
  } else if (entryType === 'date') {
    if (!search.date) {
      return 'date';
    }
    if (!search.date1) {
      return 'date1';
    }
    if (!search.date2) {
      return 'date2';
    }
    return `extra-${extraCount}-date`;
  } else if (entryType === 'number') {
    if (!search.number) {
      return 'number';
    }
    if (!search.number1) {
      return 'number1';
    }
    if (!search.number2) {
      return 'number2';
    }
    return `extra-${extraCount}-number`;
  }
  return null;
}

function upsertSearchCondition(search: any, fieldName: any, condition: number) {
  const prev = search.searchConditions ?? [];

  const filtered = prev.filter(
    (c: any) => c.fieldName !== fieldName
  );

  return [
    ...filtered,
    { fieldName, condition }
  ];
}

function mapPresetValueToSearch(columnId: any, value: any, search: any, presetSlot: any, searchCondition: number) {
  if (!presetSlot) {
    return search;
  }

  let nextSearch = { ...search };

  if (presetSlot.startsWith('extra')) {
    const extraParts = presetSlot.split('-');
    const extraIndex = parseInt(extraParts[1], 10);
    const extraSlot = extraParts[2];

    let tempSearchExtras = nextSearch.extras ? [...nextSearch.extras] : [];

    const extraCount = tempSearchExtras.length;

    if (tempSearchExtras.length === 0 || (extraIndex >= (extraCount - 1) && tempSearchExtras[extraIndex]?.extraSlot !== columnId)) {
      tempSearchExtras[extraIndex] = { extraSlot: columnId };
    }

    if (extraSlot === 'general') {
      nextSearch = {
        ...nextSearch,
        searchConditions: upsertSearchCondition(nextSearch, columnId, searchCondition)
      };

      tempSearchExtras[extraIndex] = {
        ...tempSearchExtras[extraIndex],
        generalText: value
      };
    }
    else if (extraSlot === 'date') {
      tempSearchExtras[extraIndex] = {
        ...tempSearchExtras[extraIndex],
        dateFrom: value?.from,
        dateTo: value?.to
      };
    }
    else if (extraSlot === 'number') {
      tempSearchExtras[extraIndex] = {
        ...tempSearchExtras[extraIndex],
        numberFrom: value?.from,
        numberTo: value?.to
      };
    }

    return {
      ...nextSearch,
      extras: tempSearchExtras
    };
  }

  if (presetSlot === 'general1') {
    return {
      ...nextSearch,
      general1: columnId,
      generalText1: value,
      searchConditions: upsertSearchCondition(nextSearch, columnId, searchCondition)
    };
  }
  else if (presetSlot === 'general2') {
    return {
      ...nextSearch,
      general2: columnId,
      generalText2: value,
      searchConditions: upsertSearchCondition(nextSearch, columnId, searchCondition)
    };
  }
  else if (presetSlot === 'general3') {
    return {
      ...nextSearch,
      general3: columnId,
      generalText3: value,
      searchConditions: upsertSearchCondition(nextSearch, columnId, searchCondition)
    };
  }
  else if (presetSlot === 'date') {
    return {
      ...nextSearch,
      date: columnId,
      dateFrom: value?.from,
      dateTo: value?.to
    };
  }
  else if (presetSlot === 'date1') {
    return {
      ...nextSearch,
      date1: columnId,
      dateFrom1: value?.from,
      dateTo1: value?.to
    };
  }
  else if (presetSlot === 'date2') {
    return {
      ...nextSearch,
      date2: columnId,
      dateFrom2: value?.from,
      dateTo2: value?.to
    };
  }
  else if (presetSlot === 'number') {
    return {
      ...nextSearch,
      number: columnId,
      numberFrom: value?.from,
      numberTo: value?.to
    };
  }
  else if (presetSlot === 'number1') {
    return {
      ...nextSearch,
      number1: columnId,
      numberFrom1: value?.from,
      numberTo1: value?.to
    };
  }
  else if (presetSlot === 'number2') {
    return {
      ...nextSearch,
      number2: columnId,
      numberFrom2: value?.from,
      numberTo2: value?.to
    };
  }

  return nextSearch;
}

function setPresetValue(value:any, setValue:any, entryType:any) {
  if (!entryType) {
    return;
  }

  if (entryType === 'date' || entryType === 'number') {
       setValue({from: value?.from, to: value?.to });
  } else {
    setValue(value);
  }
}

function FilterDrawer({
  // breakNo,
  // width,
  onSearch,
  onClick, /* Search button click */
  searchStorage,
  setFilterOrderInStorage,
  hidden,
  ...other
}:any) {
  const [showGlobalOkDialog] = useGlobalOkDialog();
  
  const [isPaneOpen, _setIsPaneOpen] = useState(false);

  const [filterColumnPreset, setFilterColumnPreset] = useState<any>(null);
  //const [filterOrder, _setFilterOrder] = useState<any>(other?.filterOrder);
  const [filterValue, _setFilterValue] = useState<any>(null);

  const multipleSearchRef = useRef<boolean>(false);
  const [isMultipleSearchChecked, setIsMultipleSearchChecked] = useState(false);

  const dateNotNullRef = useRef<boolean>(false);
  const [isDateNotNullChecked, _setIsDateNotNullChecked] = useState(false);

  // const [isExactSearchChecked, setIsExactSearchChecked] = useState(false);
  const createdByAiAgentSnapshotRef = useRef<boolean>(false);
  
  // Client Setup의 Default Search Option (C: Contains, S: Start With, E: Exact Match)
  const appContext = useContext(ApplicationContext);
  const defaultSearchOption = appContext.defaultSearchOption === 'S' ? 1 : appContext.defaultSearchOption === 'E' ? 2 : 0;
  const defaultSearchOptionRef = useRef<number>(defaultSearchOption);
  defaultSearchOptionRef.current = defaultSearchOption;

  const [selectedSearchOption, setSelectedSearchOption] = useState<number>(defaultSearchOption);
  const [deleteFilterFieldNames, setDeleteFilterFieldNames] = useState<Array<string>>([]);
  const searchOptionRef = useRef<number>(0);
  const filterValueRef = useRef<any>(null);

  const noNullOrEmptySearches = other.noNullOrEmptySearches;
  const isNullSearchEnableColumn = nullSearchEnableColumns.some(x => x === filterColumnPreset);
  
  const filterOrderRef = useRef(other?.filterOrder ?? []);

  function setFilterValue(value:any){
    filterValueRef.current = value;
    _setFilterValue(value);
  }

  function setIsDateNotNullChecked(value:boolean){
    dateNotNullRef.current = value;
    _setIsDateNotNullChecked(value);
  }

  function setFilterOrder(f:any) {
    filterOrderRef.current = f;
    setFilterOrderInStorage(f);
    //_setFilterOrder(f);
  }

function setIsPaneOpen(open:any) {
  _setIsPaneOpen(open);
  if (open) {
    createdByAiAgentSnapshotRef.current = !!searchRef.current.createdByAiAgent;
  } else {
    setDeleteFilterFieldNames([]);
    setFilterColumnPreset(null);
    setFilterValue(null);
  }
}

  const [search, _setSearch] = useState(searchStorage);
  const searchRef = useRef(search);

  function setSearch(data: any) {
    searchRef.current = data;
    _setSearch(searchRef.current);
  }

  let clearSubscription:ISubscriptionDefinition<any>|null = null;
  let presetSubscription:ISubscriptionDefinition<any>|null = null;
  let countSubscription:ISubscriptionDefinition<any>|null = null;
  let dismissSubscription:ISubscriptionDefinition<any>|null = null;

  function subscribeChannels() {
    presetSubscription = postal.subscribe({
      channel: 'ifms-filter',
      topic: 'ifms-filter.preset',
      callback: ({columnId, value}) => {
        const entryType = getPresetType(columnId, other);
        if (!entryType) {
          // Column is not searchable
          return;
        }

        if (entryType === 'date') {
          const parseResult = dateTextToIso(value);
          if (parseResult.valid) {
            setFilterValue({ from: null, to: null });
          } else {
            setFilterValue({ from: null, to: null });
          }
        } 
        else if (entryType === 'number') {
          setFilterValue({ from: parseFloat(value.replaceAll(',','')), to: null });
        }
        else if (entryType === 'bool') {
          setFilterValue(value);
        } else {
          setFilterValue(_.isEmpty(value.trim()) ? null : value.trim());
        }
        setFilterColumnPreset(columnId);

        setIsPaneOpen(true);
      },
    });
    countSubscription = postal.subscribe({
      channel: 'ifms-filter',
      topic: 'ifms-filter.count',
      callback: setCount,
    });
    dismissSubscription = postal.subscribe({
      channel: 'ifms-filter',
      topic: 'ifms-filter.dismiss',
      callback: dismiss,
    });
  }

  function unsubscribeChannels() {
    if (clearSubscription) {
      postal.unsubscribe(clearSubscription);
    }
    if (presetSubscription) {
      postal.unsubscribe(presetSubscription);
    }
    if (countSubscription) {
      postal.unsubscribe(countSubscription);
    }
    if (dismissSubscription) {
      postal.unsubscribe(dismissSubscription);
    }
  }

  function setPageSize(pageSize:any) { 
    setSearch({...searchRef.current, pageSize}); 
  }

  useEffect(() => {
    multipleSearchRef.current = isMultipleSearchChecked;
  }, [isMultipleSearchChecked]);

  useEffect(() => {
    searchOptionRef.current = selectedSearchOption;
  }, [selectedSearchOption]);

  useEffect(() => {
    setSelectedSearchOption(defaultSearchOption);
  }, [defaultSearchOption]);

  useEffect(() => {
    subscribeChannels();

    return () => {
      unsubscribeChannels();
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  function dismiss() {
    setNullOrEmpty(false);
    setIsDateNotNullChecked(false);
    setIsMultipleSearchChecked(false);
    setSelectedSearchOption(defaultSearchOptionRef.current);
    setOrderByAscending(false);
    setIsPaneOpen(false);
     setSearch({ ...searchRef.current, createdByAiAgent: createdByAiAgentSnapshotRef.current });
    // setIsExactSearchChecked(false);
  }

  function setNullOrEmpty(value: any) {
    if (typeof value === 'string') { //for status, recognized
      value = value.length === 0;
    }
    setSearch({
      ...searchRef.current,
      generalNullOrEmpty: value,
      dateNullOrEmpty: value,
      numberNullOrEmpty: value,
    });
  }

  function setOrderByAscending(value: boolean) {
    setSearch({
      ...searchRef.current,
      orderByAscending : value
    });
  }

  function clearEmptySearchPointers(s: Search): Search {
    const cleaned = { ...s };
    if (cleaned.general1 && !cleaned.generalText1) cleaned.general1 = '';
    if (cleaned.general2 && !cleaned.generalText2) cleaned.general2 = '';
    if (cleaned.general3 && !cleaned.generalText3) cleaned.general3 = '';
    if (cleaned.date && !cleaned.dateFrom && !cleaned.dateTo) cleaned.date = '';
    if (cleaned.date1 && !cleaned.dateFrom1 && !cleaned.dateTo1) cleaned.date1 = '';
    if (cleaned.date2 && !cleaned.dateFrom2 && !cleaned.dateTo2) cleaned.date2 = '';
    if (cleaned.number && cleaned.numberFrom == null && cleaned.numberTo == null) cleaned.number = '';
    if (cleaned.number1 && cleaned.numberFrom1 == null && cleaned.numberTo1 == null) cleaned.number1 = '';
    if (cleaned.number2 && cleaned.numberFrom2 == null && cleaned.numberTo2 == null) cleaned.number2 = '';
    return cleaned;
  }



  function setCreatedByAiAgent(value: boolean) {
    setSearch({
      ...clearEmptySearchPointers(searchRef.current),
      createdByAiAgent: value,
    });
  }

  function setCount({search, count}:any) {
    const filterIndex = filterOrderRef.current?.findIndex((x:any) => searchInFilterOrderComparer(x.s, search)); 

    if (filterIndex >= 0) {
      const f:any = [...filterOrderRef.current];
      if (f[filterIndex] && f[filterIndex].count !== count) {
        const newFilterOrder = _.cloneDeep(f[filterIndex]);
        newFilterOrder.count = count;
        f[filterIndex] = newFilterOrder;
        setFilterOrder(f);
      }
    }
  }

  //Need when open the Search View and use apply button immediately with a empty('') value
  function isSpecialHeaderWithEmptyValue() {
    if (!search.generalNullOrEmpty)
      return isNullSearchEnableColumn;
    else
      return true;
  }

  function getSearchCondition(search: Search, columnId: string): number {
    const cond = search.searchConditions?.find(
      c => c.fieldName === columnId
    );
    return cond ? cond.condition : 0;
  }

  function extractSearchEntries(search: Search) {
    const entries: any[] = [];

    // general
    if (search.general1)
      entries.push({
        columnId: search.general1,
        type: 'general',
        value: search.generalText1,
        searchCondition: getSearchCondition(search, search.general1)
      });

    if (search.general2)
      entries.push({
        columnId: search.general2,
        type: 'general',
        value: search.generalText2,
        searchCondition: getSearchCondition(search, search.general2)
      });

    if (search.general3)
      entries.push({
        columnId: search.general3,
        type: 'general',
        value: search.generalText3,
        searchCondition: getSearchCondition(search, search.general3)
      });

    // date
    [['', ''], ['1', '1'], ['2', '2']].forEach(([idx]) => {
      const from = (search as any)[`dateFrom${idx}`];
      const to = (search as any)[`dateTo${idx}`];
      const col = (search as any)[`date${idx}`];
      if (col)
        entries.push({
          columnId: col,
          type: 'date',
          from,
          to
        });
    });

    // number
    [['', ''], ['1', '1'], ['2', '2']].forEach(([idx]) => {
      const from = (search as any)[`numberFrom${idx}`];
      const to = (search as any)[`numberTo${idx}`];
      const col = (search as any)[`number${idx}`];
      if (col)
        entries.push({
          columnId: col,
          type: 'number',
          from,
          to
        });
    });

    // extras
    search.extras?.forEach(extra => {
      if (extra.generalText)
        entries.push({
          columnId: extra.extraSlot,
          type: 'general',
          value: extra.generalText,
          searchCondition: getSearchCondition(search, extra.extraSlot)
        }); 
      else if (extra.dateFrom || extra.dateTo)
        entries.push({
          columnId: extra.extraSlot,
          type: 'date',
          from: extra.dateFrom,
          to: extra.dateTo
        });
      else if (extra.numberFrom || extra.numberTo)
        entries.push({
          columnId: extra.extraSlot,
          type: 'number',
          from: extra.numberFrom,
          to: extra.numberTo
        });
    });

    return entries;
  }

  function cleanSearchByDeleteFields(search: Search, deleteFieldNames: string[], multipleSearch: boolean): Search {
    if (!deleteFieldNames?.length) return search;
  
    const entries = extractSearchEntries(search);
    const remainedEntries = entries.filter(x => !deleteFieldNames.includes(x.columnId));

    let rebuiltSearch: Search = {
      ...search,
      extras: [],
      general1: '',
      general2: '',
      general3: '',
      generalText1: '',
      generalText2: '',
      generalText3: '',
      date: '',
      date1: '',
      date2: '',
      dateFrom: null,
      dateTo: null,
      dateFrom1: null,
      dateTo1: null,
      dateFrom2: null,
      dateTo2: null,
      number: '',
      number1: '',
      number2: '',
      numberFrom: null,
      numberTo: null,
      numberFrom1: null,
      numberTo1: null,
      numberFrom2: null,
      numberTo2: null,
      searchConditions: [],
      dateNotNullFields: (search.dateNotNullFields ?? []).filter(x => !deleteFieldNames.includes(x))
    };
  
    for (const entry of remainedEntries) {
      const slot = getPresetEmptySlot(rebuiltSearch, entry.type, multipleSearch);
      const value = entry.type === 'date' || entry.type === 'number' ? { from: entry.from, to: entry.to } : entry.value;

      rebuiltSearch = mapPresetValueToSearch(entry.columnId, value, rebuiltSearch, slot, entry.searchCondition);
    }

    return rebuiltSearch;
  }

  function removeFilterOrderByFieldNames(filterOrder: any[], deleteFilterFieldNames: string[]) {
    return filterOrder.filter(x => !deleteFilterFieldNames.includes(x.columnId));
  }

  function findSlotByColumnId(search: Search, columnId: string): string | null {
    if (search.general1 === columnId) return 'general1';
    if (search.general2 === columnId) return 'general2';
    if (search.general3 === columnId) return 'general3';

    if (search.date === columnId) return 'date';
    if (search.date1 === columnId) return 'date1';
    if (search.date2 === columnId) return 'date2';

    if (search.number === columnId) return 'number';
    if (search.number1 === columnId) return 'number1';
    if (search.number2 === columnId) return 'number2';

    if (search.extras?.length) {
      for (let i = 0; i < search.extras.length; i++) {
        const extra = search.extras[i];
        if (extra.extraSlot === columnId) {
          if (extra.generalText !== null)
            return `extra-${i}-general`;
          if (extra.dateFrom !== null || extra.dateTo !== null)
            return `extra-${i}-date`;
          if (extra.numberFrom !== null || extra.numberTo !== null)
            return `extra-${i}-number`;
        }
      }
    }

    return null;
  }

  function syncFilterOrderSlotWithSearch(filterOrder: any[], search: Search) {
    return filterOrder.map(entry => {
      const newSlot = findSlotByColumnId(search, entry.columnId);

      return {
        ...entry,
        slot: newSlot,
        s: _.cloneDeep(search)
      };
    });
  }

function applySearch(applyPageSize: boolean = false) {
    const recalcApplyButtonDisable = search.createdByAiAgent
    ? false
    : entryType === 'number' || entryType ==='date' 
    ? ((filterValueRef.current?.from === '' || filterValueRef.current?.from === null) && (filterValueRef.current?.to === '' || filterValueRef.current?.to === null) && !(search.dateNullOrEmpty || search.numberNullOrEmpty || dateNotNullRef.current)
      || (entryType === 'number' ? false : isInvalidDate ))
    : ((filterValueRef.current === '' || filterValueRef.current === null) && !search.generalNullOrEmpty) && !isNullSearchEnableColumn;
    
    if (recalcApplyButtonDisable && !applyPageSize) return;

    if (!filterColumnPreset) {
      setIsPaneOpen(false);
      onSearch(search, filterOrderRef.current);
      return;
    }

    let newSearch = multipleSearchRef.current
      ? { ...search }
      : { ...(other.externalSetSearchInStorage ?? resetSearchKeepPaging(search)) };

    // 기존 search에서 deleteFilterFieldNames를 순회하며 제외된 조건들을 없애고 search 객체를 다시 정의함
    newSearch = cleanSearchByDeleteFields(newSearch, deleteFilterFieldNames, multipleSearchRef.current);

    const url = `${window.location.pathname}${window.location.search}`;
    const isShipStatusList = url.includes('/common/joblistview/RPCSP/shipmentStatus');
    //Shipment Status List > ListFilter가 걸린 상태에서 Column에서 Multiple Search할때 listType이 0으로 초기화되어 강제로 listType에 현재 List Filter에 걸린 값 입력하기 위해 추가
    if(isShipStatusList && (search.listType || search.listType2 || search.listType3 || search.listType4)){
      newSearch.listType = search.listType;
      newSearch.listType2 = search.listType2;
      newSearch.listType3 = search.listType3;
      newSearch.listType4 = search.listType4;
    }
    //search.generalNullOrEmpty = isSpecialHeaderWithEmptyValue();
    newSearch.generalNullOrEmpty = isSpecialHeaderWithEmptyValue();
    newSearch.dateNullOrEmpty = search.dateNullOrEmpty;
    newSearch.numberNullOrEmpty = search.numberNullOrEmpty;
    newSearch.createdByAiAgent = search.createdByAiAgent;

    const prevDateNotNullFields = (newSearch.dateNotNullFields ?? []).filter((x:string) => x !== filterColumnPreset);
    newSearch.dateNotNullFields = dateNotNullRef.current ? [...prevDateNotNullFields, filterColumnPreset] : prevDateNotNullFields;
    newSearch.pageSize = search.pageSize;
    if (!newSearch.orderByAscending && (entryType === 'number' || entryType === 'general'))
      newSearch.orderByAscending = true;
    newSearch.orderBy = filterColumnPreset;
    newSearch.isExpressSearch = false;    //Express Search 검색이 아닌 F5 단축키 또는 우클릭 메뉴를 통해 검색할 경우 기존 검색방식으로 동작하도록 하기 위해 추가

    let nextFilterOrder = filterOrderRef.current;

    if (deleteFilterFieldNames.length > 0) {
      nextFilterOrder = removeFilterOrderByFieldNames(nextFilterOrder, deleteFilterFieldNames);
      nextFilterOrder = syncFilterOrderSlotWithSearch(nextFilterOrder, newSearch);
    }

    const existingEntryIndex = nextFilterOrder.findIndex((x:any) => x.columnId === filterColumnPreset);
    let filterSlot = existingEntryIndex >= 0 && multipleSearchRef.current ? (nextFilterOrder[existingEntryIndex] as any|null|undefined)?.slot : null;

    let filterSlotOverride = true;

    if (!filterSlot) {
      filterSlot = getPresetEmptySlot(newSearch, entryType, multipleSearchRef.current);
      filterSlotOverride = false;
    }


    //3.3 참고
    //대괄호에 해당하는 구문은 like 검색의 와일드카드 문자로 사용되어 입력문자 그대로 검색할 경우 정상적으로 작동하지 않음
    //대괄호 사이에[]를 넣어줘야함.  **ex) [USD] -> [[] USD] 이 형식으로 Query가 실행되어야 함.

    let tempFilterValue = filterValueRef.current;
    if(typeof tempFilterValue === 'string'){
      tempFilterValue = tempFilterValue.replaceAll("[", "[[]");
    }
    
    newSearch = mapPresetValueToSearch(filterColumnPreset, tempFilterValue, newSearch, filterSlot, searchOptionRef.current);
    //newSearch = mapPresetValueToSearch(filterColumnPreset, filterValueRef.current, newSearch, filterSlot, searchOptionRef.current);

  if (newSearch.createdByAiAgent) {
    newSearch = clearEmptySearchPointers(newSearch);
  }

    let displayValue = filterValueRef.current;
    if(!newSearch.createdByAiAgent && !nullSearchEnableColumns.includes(filterColumnPreset) && displayValue === '') return; 
    if (entryType === 'date' && dateNotNullRef.current) {
      displayValue = dateNotNullLabel;
    } else if (entryType === 'number' || entryType ==='date') {
      displayValue = `${filterValueRef.current?.from || ''} ~ ${filterValueRef.current?.to || ''}`;
    } else {
      const customRenderer = customRenderers.find((x:any) => x.accessor === filterColumnPreset);
      if (customRenderer?.displayValueExtractor) {
        displayValue = customRenderer.displayValueExtractor(displayValue);
      }
    }
    
    const newFilterOrderEntry = {
      columnId: filterColumnPreset,
      slot: filterSlot,
      type: entryType,
      label: filterLabel,
      value: displayValue,
      s: _.cloneDeep(newSearch),
    };

    if (!filterSlotOverride) {
      if (multipleSearchRef.current) {
        setFilterOrder([newFilterOrderEntry, ...nextFilterOrder]);
      } else {
        setFilterOrder([newFilterOrderEntry]);
      }
    } else {
      if (multipleSearchRef.current) {
        const multipleOf: any[] = [newFilterOrderEntry, ...nextFilterOrder];
        multipleOf.splice(existingEntryIndex + 1, 1);
        setFilterOrder(multipleOf);
      } else {
        setFilterOrder([newFilterOrderEntry]);
      }
    }

    setSearch(newSearch);
    setIsPaneOpen(false);

    onSearch(newSearch, filterOrderRef.current);
  }

  /*
  function applyPageSize() {
    applySearch(true);
  }
*/

  function focusEntry() {
    const dataEntryContainer = document.getElementById('ifms-filter-entry-container');
    if (!dataEntryContainer) {
      return;
    }

    if (dataEntryContainer) {
      let focusNode:any = null;

      const tabableElements = dataEntryContainer.querySelectorAll('.ifms-tabable-active');
      if (tabableElements && tabableElements.length > 0) {
        focusNode = tabableElements[0];
      }

      if (focusNode) {
        if (focusNode.focus) {
          focusNode.focus();
        }
        if (focusNode.select) {
          focusNode.select();
        }
      }
    }
    setNullOrEmpty(false);
    setIsDateNotNullChecked((searchRef.current.dateNotNullFields ?? []).some((x:string) => x === filterColumnPreset));
    setOrderByAscending(false);
    let isMultiple = false;
    if (filterOrderRef.current !== undefined && filterOrderRef.current.length > 0) {
      if (shouldResetFiltersOnApply()) {
        isMultiple = false;
      }
      else if (filterOrderRef.current.length === 1 && filterOrderRef.current[0].label === filterLabel) {
        isMultiple = false;
      } 
      else {
        isMultiple = true;
      }
      if (filterOrderRef.current[0].switchList) {
        isMultiple = false;
      }
    }
    setIsMultipleSearchChecked(isMultiple);
  }
  const customRenderers: ListCustomFilterRenderer[] = other.customRenderers || [];

  const entryType = getPresetType(filterColumnPreset, other);
  let filterLabel = getFilterLabel(filterColumnPreset, entryType, other);

  //const showmultipleSearch = !!filterOrder && filterOrder.filter((x:any) => x.columnId !== filterColumnPreset).length > 0;
  const decimals = getDecimals(filterColumnPreset, other);
  const floatOverride = (decimals === 0 ? true : false);

  const suntekSettings = useSuntekSettings();
  const dateformat = suntekSettings.company?.dateFormat.toUpperCase() || '';
  const isInvalidDate = getinvalidDate(filterValue?.from, filterValue?.to);
  const useCustomRenderes = customRenderers.some(x => x.accessor === filterColumnPreset);

  const applyButtonDisable = search.createdByAiAgent
  ? false
  :  entryType === 'number' || entryType ==='date' 
  ? ((filterValue?.from === '' || filterValue?.from === null) && (filterValue?.to === '' || filterValue?.to === null) && !(search.dateNullOrEmpty || search.numberNullOrEmpty || isDateNotNullChecked)
        || (entryType === 'number' ? false : isInvalidDate ))
  : ((filterValue === '' || filterValue === null) && !search.generalNullOrEmpty) && !isNullSearchEnableColumn;

  function onEntryValueChange(value:any) {
    setPresetValue(value, setFilterValue, entryType);
  }

  function getinvalidDate(from: string, to: string){
    if(entryType === 'date'){
      if(from || to){
        if(from && from.length <= 9 || to && to.length <= 9){
          return true;
        } else {
          if(from && to){
            const result1 = formatDate(from, dateformat);
            const result2 = formatDate(to, dateformat);
            if (result1.toLocaleLowerCase() !== 'invalid date' && result2.toLocaleLowerCase() !== 'invalid date') return false;
            else return true;
          }
          else if (from){
            const result1 = formatDate(from, dateformat);
            if (result1.toLocaleLowerCase() !== 'invalid date') return false;
            else return true;
          }
          else {
            const result2 = formatDate(to, dateformat);
            if (result2.toLocaleLowerCase() !== 'invalid date') return false;
            else return true;
          }
        }
      } else {
        return false;
      }
    } 
    else{
      return false;
    }
  }

  function getDecimals(columnAccessor: any, other: any) {
    const numberFilters = other.numberFilters;
    const formatString: string = numberFilters.find((x:any) => x.accessor === columnAccessor)?.formatString || '';
    let ret = formatString.slice(formatString.lastIndexOf(".")).length;

    if (ret === 0) ret = 2;
    else if (ret > 0) ret--;

    return ret;
  }

  function shouldResetFiltersOnApply() {
    return filterOrderRef.current.length > 0 && filterOrderRef.current.findIndex((x: any) => x.columnId === filterColumnPreset) > 0;
  }

  function onShowFunc() {
    focusEntry();

    if (shouldResetFiltersOnApply())
      showGlobalOkDialog(
        <p>
          The current search condition is located in the middle of Search History.
          <br />
          <span>
            Applying it will reset filters and start a new search.
          </span>
        </p>,
        false,
        null,
        'warning'
      );
  }

  const url = `${window.location.pathname}${window.location.search}`;
  const isShipStatusList = url.includes('/common/joblistview/RPCSP/shipmentStatus');
  const isAMSList = url.includes('/ams');
  const isISFList = url.includes('/isf');
  const isTaskBoardList = url.includes('/home');
  const isCustomizeList = url.includes('/common/joblistview/CTLST/opReport');
  const isCreatedByAiAgentTargetList = 
  url.includes('/common/joblistview/mbl/oceanImport') ||
  url.includes('/common/joblistview/hbl/oceanImport') ||
  url.includes('/common/joblistview/crdb') ||
  url.includes('/common/joblistview/bill');

const showCreatedByAiAgentFilter = isCreatedByAiAgentTargetList;
  
  return (
    <>
      {(isAMSList || isISFList) ?
        <IconButton size='imgStyle' onClick={onClick} name='search-button' style={{ display: `${hidden ? 'None' : 'inline-block'}`, paddingTop: '2px' }} data-tooltip='Multi Search' icon={appContext.useDarkMode ? SearchIcon2_D : SearchIcon2}>
        </IconButton>
        :
        (isTaskBoardList ? 
          <IconButton iconHeight="24px" style={{alignItems: 'center', justifyContent: 'center'}}  disabled={hidden} onClick={onClick} name='search-button' data-tooltip='Multi Search' icon={appContext.useDarkMode ? SearchIcon4_D : SearchIcon4}>
          </IconButton>
          : (appContext.suntekSettings?.company?.billingsTabVersion === 2 ?
              <>
                {!isCustomizeList &&
                <IconButton iconHeight="24px" disabled={hidden} onClick={onClick} name='search-button' data-tooltip='Multi Search' icon={appContext.useDarkMode ? SearchIcon4_D : SearchIcon4}>
                </IconButton> }
              </>
              :
            (isShipStatusList ?
              <PrimaryButton size="extrasmall" onClick={onClick} name='search-button' style={{ display: `${hidden ? 'None' : 'inline-block'}` }}>Multi Search</PrimaryButton>
            :
            <>{!isCustomizeList &&
            <IconButton  iconHeight="24px"  onClick={onClick} name='search-button' style={{ display: `${hidden ? 'None' : 'inline-block'}`, paddingTop: '2px' }} data-tooltip='Multi Search' icon={appContext.useDarkMode ? SearchIcon4_D : SearchIcon4}>
            </IconButton>}</>
            )
          )
        )
      }

      <IfmsModal isBlueHeader isOpen={isPaneOpen} title={`${extractScreenTitleBar()} Multi Search - ${filterLabel}`} onCancel={dismiss} width="590px" onShow={onShowFunc} draggable isSearch>
        <div className='report-popup'>
          <div>
            {/* jhlee.251210.Issue#3183 - Search Exact Match Only 제거하고, 3개의 Contains, Start With, Exact Match 옵션 버튼을 추가 */}
            {/* {entryType === 'general' && !useCustomRenderes && filterColumnPreset !== 'status'?
              <div style={{ width: '230px', marginLeft: '20px' }}>
                <LabeledCheckBox name='search-exactmatchonly' reverse labelSize="210px" label="Search Exact Match Only" value={isExactSearchChecked} onChange={(value) => { setIsExactSearchChecked(value); }} />
              </div>
              :
              <></>
            } */}
            {entryType === 'general' && !useCustomRenderes && filterColumnPreset !== 'status'
              ? <>
                  <div style={{ width: '400px', display: 'flex', marginLeft:'10px' }}>
                    <div style={{ flex: 1, display: 'flex' }}>
                      <RadioButton boldOnActive group='search-options' reverse label='Contains'
                        checked={selectedSearchOption === 0} 
                        onChecked={() => setSelectedSearchOption(0)} 
                      />  
                    </div>

                    <div style={{ flex: 1, display: 'flex' }}>
                      <RadioButton boldOnActive group='search-options' reverse label='Start With'
                        checked={selectedSearchOption === 1}
                        onChecked={() => setSelectedSearchOption(1)}  
                      />
                    </div>

                    <div style={{ flex: 1, display: 'flex' }}>
                      <RadioButton boldOnActive group='search-options' reverse label='Exact Match'
                        checked={selectedSearchOption === 2} 
                        onChecked={() => setSelectedSearchOption(2)}
                      />
                    </div>
                  </div>
                </>
              : <></>
            }
            {entryType === 'date' ?
              <div style={{ width: '230px', marginLeft: '10px', marginBottom: '10px' }}>
                <LabeledCheckBox name='search-sort-by-descending' reverse labelSize="215px" label="Sort by Descending" value={!search.orderByAscending} onChange={value => { setOrderByAscending(!value) }} />
              </div>
              :
              <></>
            }
            <FilterContent id="ifms-list-screen-filter">
              <div className="filter-entry-container">
                <div id="ifms-filter-entry-container" className="filter-entry-data">
                  <FilterEntry
                    filterId={filterColumnPreset}
                    filterLabel={filterLabel}
                    entryType={entryType}
                    value={filterValue}
                    onChange={onEntryValueChange}
                    nullOrEmpty={search.generalNullOrEmpty || search.dateNullOrEmpty || search.numberNullOrEmpty}
                    setNullOrEmpty={setNullOrEmpty}
                    dateNotNull={isDateNotNullChecked}
                    setDateNotNull={setIsDateNotNullChecked}
                    customRenderers={customRenderers}
                    applySearch={applySearch}
                    floatOverride={floatOverride}
                    decimals={decimals}
                    noNullOrEmptySearches={noNullOrEmptySearches}
                    useCustomRenderes={useCustomRenderes}
                  />
                  {showCreatedByAiAgentFilter && (
                    <div style={{ width: '230px', marginTop: '10px' }}>
                      <LabeledCheckBox
                        name='search-createdByAiAgent'
                        reverse
                        labelSize="215px"
                        label="Created by AI Agent"
                        value={search.createdByAiAgent}
                        onChange={(value) => { setCreatedByAiAgent(value); }}
                      />
                    </div>
                  )}
                  {!shouldResetFiltersOnApply() &&
                    <div style={{ width: '230px' }}>
                      <LabeledCheckBox name='search-multipleSearch' reverse labelSize="215px" label="Multi Search" value={isMultipleSearchChecked} onChange={(value) => { setIsMultipleSearchChecked(value); }} />
                    </div>
                  }
                </div>
              </div>
            </FilterContent>
          </div>
          
          <div className="filter-info-container">
            {/* <div className="filter-popup-pager">
              <div className="filter-popup-pager-label">
                Max Records
              </div>
              <div className="filter-popup-pager-entry">
                <Number name='ifms-filter-maxRecords' value={search.pageSize} onChange={setPageSize} min={1} max={65000} />
              </div>
              <div className="filter-popup-pager-label">
                (*Max=65,000)
              </div>
            </div> */}
            <div className="filter-info-summary">
              <FilterSummary
                filterOrder={filterOrderRef.current}
                search={search}
                filterId={filterColumnPreset}
                deleteFilterFieldNames={deleteFilterFieldNames}
                setDeleteFilterFieldNames={setDeleteFilterFieldNames}
                isMultipleSearchChecked={isMultipleSearchChecked}
              />
            </div>
          </div>
          
          <div className="clearfix"></div>

          <div className="report-footer" >
            <SecondaryButton name='applyButton' size="regular" focusable={true} onClick={applySearch} disabled={applyButtonDisable} >
              Apply
            </SecondaryButton>&nbsp;&nbsp;
            <SecondaryButton name='cancelButton' size="regular" focusable={true} onClick={dismiss}>
              Cancel
            </SecondaryButton>
          </div>
        </div>
      </IfmsModal>
    </>
  );
}

FilterDrawer.propTypes = {
};

// Don't use memo, it will break useFilterBar hook
export default FilterDrawer;
